import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-soldproperty',
  templateUrl: './soldproperty.component.html',
  styleUrls: ['./soldproperty.component.css']
})
export class SoldpropertyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/saledeed/soldproperty/soldproperty.component.ts